import { isValidPhoneNumber } from "libphonenumber-js";

import { t } from 'application-translator/dist/translate/translate.react.js';

const result = {
  error: false,
  message: "",
};

export const validatePhoneNumber = (value, country) => {
  const isValid = isValidPhoneNumber(value, country);

  result.error = !isValid;
  result.message = !isValid ? t("Invalid mobile number") : null;

  return result;
};

export const validateEmail = (value) => {
  const pattern =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const isValid = pattern.test(String(value).toLowerCase());
  result.error = !isValid;
  result.message = !isValid ? t("Invalid email address") : null;

  return result;
};

export const validateFields = (type, value) => {
  switch (type) {
    case "email":
      validateEmail(value);
      break;

    case "required":
      result.error = !value;
      result.message = !value ? t("This field is required") : "";
      break;

    default:
      break;
  }
  return result;
};
